export default function errorAction(context) {
  const routeName = context?.route?.name;
  const componentName = context?.component?.name;

  if (!routeName && !componentName) return null;

  return `${routeName || 'unknown'}#${componentName || 'Unknown'}`;
}
